<template>

</template>

<script>
  export default {
    name: 'homepage',
    computed: {

    },
    components: {

    }
  }
</script>



// WEBPACK FOOTER //
// homepage.vue?783e69db